// Module
var code = "<ng-transclude ng-transclude-slot=\"heading\"></ng-transclude><ng-transclude ng-transclude-slot=\"body\"></ng-transclude><ng-transclude ng-transclude-slot=\"footer\"></ng-transclude>";
// Exports
module.exports = code;